var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view"},[_c('Header'),_c('div',{staticClass:"content-box"},[_c('div',{staticClass:"content"},[_c('router-view')],1)]),_c('Footer'),_c('floatBar'),_c('codeModal'),_c('enterModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }